const crypto = require('crypto');

const jose = require('node-jose');
const forge = require('node-forge');
const NodeRSA = require('node-rsa');

export const JWE_KEY = 'jwe_key';
/*
const publicKeyOtalent = '-----BEGIN RSA PUBLIC KEY-----\n'
  + 'MIIBCgKCAQEAgczn38xQfPMxcd2GH3APGw3e4o9hg3CB4OKRZ/d8T/1LDShfuG4j\n'
  + 'xqL1w/6GnG0poH1K0uyV6e6J6e6En4qMtrvyJDiFAqWQPjBIlpb6V8/j/DEWsmzz\n'
  + 'VgMAOkdNHrxLphktqjQSD+l3TK1fWVAfUoDQSzqSsqLqFSGH2Yhdrgv5K0aHW9kr\n'
  + '5JrzEMTswEVQy6bE0f3ig6Syp0/2CX9ol/TbM0knp+dPqHoQPBNl+r1HGHDNJ3uk\n'
  + 'vP7zFvGgQnPym27owNytlrKJtJK6nf+DQcArCoSt2CbJI48xw7E2yTmRCrGxRKko\n'
  + 'MtiS6RN05eYxs9u+Eldhm6mOBcQI7iEOoQIDAQAB\n'
  + '-----END RSA PUBLIC KEY-----'; */
const serverPublicKey = 'MIIBCgKCAQEAgczn38xQfPMxcd2GH3APGw3e4o9hg3CB4OKRZ/d8T/1LDShfuG4jxqL1w/6GnG0poH1K0uyV6e6J6e6En4qMtrvyJDiFAqWQPjBIlpb6V8/j/DEWsmzzVgMAOkdNHrxLphktqjQSD+l3TK1fWVAfUoDQSzqSsqLqFSGH2Yhdrgv5K0aHW9kr5JrzEMTswEVQy6bE0f3ig6Syp0/2CX9ol/TbM0knp+dPqHoQPBNl+r1HGHDNJ3ukvP7zFvGgQnPym27owNytlrKJtJK6nf+DQcArCoSt2CbJI48xw7E2yTmRCrGxRKkoMtiS6RN05eYxs9u+Eldhm6mOBcQI7iEOoQIDAQAB';

const key = new NodeRSA();

/**
 *
 * @param len
 * @returns {string} random hex string generated
 */
const randHex = (len) => {
  const maxlen = 8;
  // eslint-disable-next-line no-restricted-properties
  const min = Math.pow(16, Math.min(len, maxlen) - 1);
  // eslint-disable-next-line no-restricted-properties
  const max = Math.pow(16, Math.min(len, maxlen)) - 1;
  const n = Math.floor(Math.random() * (max - min + 1)) + min;
  let r = n.toString(16);
  while (r.length < len) {
    r += randHex(len - maxlen);
  }
  return r;
};

const hex = randHex(32);

export const getTransKey = () => {
  key.setOptions({ encryptionScheme: 'pkcs1' });
  key.importKey(serverPublicKey, 'pkcs1-public');

  const encryptData = key.encrypt(hex, 'hex', 'hex');

  return {
    encrypted: encryptData.toString(),
    clair: hex,
  };
};

export const aes256gcm = (keyClair) => {
  const ALGO = 'aes-128-gcm';

  // decrypt decodes base64-encoded ciphertext into a utf8-encoded string
  const decrypt = (enc, iv, authTag) => {
    const decipher = crypto.createDecipheriv(ALGO, keyClair, Buffer.from(iv, 'hex'));
    decipher.setAuthTag(authTag);
    let str = decipher.update(enc, 'hex', 'hex');
    str += decipher.final('hex');
    return str;
  };

  return {
    decrypt,
  };
};

export const getBufferHex = (data) => Buffer.from(data, 'hex');

export const getJwkKeystore = (hashKey = localStorage.getItem(JWE_KEY)) => {
  if (!hashKey) {
    throw new Error('JWE key not found in localStorage');
  }

  const jwkKey = {
    k: getBufferHex(hashKey).toString('base64'),
    kty: 'oct',
    key_ops: ['wrapKey', 'unwrapKey'],
    kid: 'otalent_key',
  };

  return jose.JWK.asKey(jwkKey).then((result) => result.keystore).catch((error) => {
    throw error;
  });
};

function b64uToUint8Array(b64u) {
  const b64 = b64u.replace(/-/g, '+').replace(/_/g, '/');
  const rem = b64.length % 4;
  const padded = rem ? b64 + '='.repeat(4 - rem) : b64;
  return Uint8Array.from(atob(padded), (c) => c.charCodeAt(0));
}

// Convert Uint8Array to binary string in chunks to avoid apply() stack overflow
function toStr(bytes) {
  const CHUNK = 8192;
  let s = '';
  for (let i = 0; i < bytes.length; i += CHUNK) {
    s += String.fromCharCode.apply(null, bytes.subarray(i, Math.min(i + CHUNK, bytes.length)));
  }
  return s;
}

function toBuf(bytes) {
  return forge.util.createBuffer(toStr(bytes));
}

// RFC 3394 AES Key Unwrap using forge AES-ECB
function aesKwUnwrap(kekBytes, wrapped) {
  const n = (wrapped.length / 8) - 1;
  let a = Array.from(wrapped.subarray(0, 8));
  const r = [];
  for (let i = 1; i <= n; i += 1) {
    r[i] = Array.from(wrapped.subarray(i * 8, (i + 1) * 8));
  }
  const kekStr = toStr(kekBytes);
  for (let j = 5; j >= 0; j -= 1) {
    for (let i = n; i >= 1; i -= 1) {
      const t = (n * j) + i;
      /* eslint-disable no-bitwise */
      const aXort = a.map((v, k) => {
        // t is always < 2^32, so upper 4 bytes of its 64-bit representation are 0
        const tByte = k < 4 ? 0 : ((t >>> (8 * (7 - k))) & 0xff);
        return v ^ tByte;
      });
      /* eslint-enable no-bitwise */
      const dec = forge.cipher.createDecipher('AES-ECB', kekStr);
      dec.start({});
      dec.update(forge.util.createBuffer(String.fromCharCode(...aXort, ...r[i])));
      const out = dec.output.getBytes(16);
      a = Array.from({ length: 8 }, (_, k) => out.charCodeAt(k));
      r[i] = Array.from({ length: 8 }, (_, k) => out.charCodeAt(8 + k));
    }
  }
  const AES_KW_IV = [0xa6, 0xa6, 0xa6, 0xa6, 0xa6, 0xa6, 0xa6, 0xa6];
  if (a.some((v, k) => v !== AES_KW_IV[k])) throw new Error('AES-KW integrity check failed');
  const cek = [];
  for (let i = 1; i <= n; i += 1) r[i].forEach((b) => cek.push(b));
  return new Uint8Array(cek);
}

export const jweDecryption = (data, keystore) => {
  if (!keystore) throw new Error('Keystore is required for decryption');
  const hexKey = localStorage.getItem(JWE_KEY);
  if (!hexKey) throw new Error('no key found');
  const kekBytes = Uint8Array.from(hexKey.match(/.{2}/g).map((b) => parseInt(b, 16)));

  const parts = data.trim().replace(/\s+/g, '').split('.');
  if (parts.length !== 5) throw new Error('Invalid JWE format');
  const [headerB64u, encKeyB64u, ivB64u, ciphertextB64u, tagB64u] = parts;

  const iv = b64uToUint8Array(ivB64u);
  const ciphertext = b64uToUint8Array(ciphertextB64u);
  const tag = b64uToUint8Array(tagB64u);

  const cek = aesKwUnwrap(kekBytes, b64uToUint8Array(encKeyB64u));
  const macKey = cek.slice(0, 16);
  const contentKey = cek.slice(16);

  // Verify HMAC-SHA256 tag per RFC 7516 — fed incrementally to avoid huge concat
  const aad = new TextEncoder().encode(headerB64u);
  const al = new Uint8Array(8);
  new DataView(al.buffer).setUint32(4, aad.length * 8);
  const hmac = forge.hmac.create();
  hmac.start('sha256', toStr(macKey));
  hmac.update(toStr(aad));
  hmac.update(toStr(iv));
  hmac.update(toStr(ciphertext));
  hmac.update(toStr(al));
  const mac = hmac.digest().getBytes();
  for (let i = 0; i < 16; i += 1) {
    if (mac.charCodeAt(i) !== tag[i]) throw new Error('Authentication tag verification failed');
  }

  // Decrypt AES-128-CBC
  const decipher = forge.cipher.createDecipher('AES-CBC', toStr(contentKey));
  decipher.start({ iv: toBuf(iv) });
  decipher.update(toBuf(ciphertext));
  if (!decipher.finish()) throw new Error('AES-CBC decryption failed');
  const plainBytes = Uint8Array.from(decipher.output.getBytes(), (c) => c.charCodeAt(0));
  return JSON.parse(new TextDecoder().decode(plainBytes));
};

export const jweEncryption = (data, keystore) => jose.JWE.createEncrypt(keystore.get('otalent_key'))
  .update(Buffer.from(JSON.stringify(data)))
  .final()
  .then(
    (result) => `${result.protected}.${result.recipients[0].encrypted_key}.${result.iv}.${result.ciphertext}.${result.tag}`,
  );
